import { observer } from "mobx-react-lite";
import React, { useMemo, useState } from "react";

import { api } from "../../../services/api/ApiService";
import { ViewSubscriptionUsage } from "../../../services/authorization/Permissions";
import { ActiveSubscriptionPlanStorageModel } from "../../../services/organization-subscription-plans/ActiveSubscriptionPlanStorage";
import { SubscriptionPlanUsageStorageModel } from "../../../services/organization-subscription-plans/SubscriptionPlanUsageStorage";
import PageLayout from "../../_layout/PageLayout";
import { SubscriptionMenuItemsModel } from "../SubscriptionMenuItems";
import "./composition.scss";
import {
  ActiveSubscriptionPlanCard,
  ContactHelp,
  StorageSpaceUsage,
  UsersAndSeatsUsage,
  VideoAnalysisUsage,
} from "./DataComponents";

export default observer(function PlanUsage() {
  const [subscriptionMenuItems] = useState(() => SubscriptionMenuItemsModel.create({}, {}));

  const [subscriptionPlanUsageStorage] = useState(() =>
    SubscriptionPlanUsageStorageModel.create({}, { api })
  );

  const [activeSubscriptionPlanStorage] = useState(() =>
    ActiveSubscriptionPlanStorageModel.create({}, { api })
  );

  const menuItems = {
    staticItems: subscriptionMenuItems.getStaticMenuItems(),
  };

  const isPageLoading = useMemo(() => {
    return subscriptionPlanUsageStorage.isLoading || activeSubscriptionPlanStorage.isLoading;
  }, [subscriptionPlanUsageStorage.isLoading, activeSubscriptionPlanStorage.isLoading]);

  return (
    <PageLayout
      accessWithOneOfThePermissions={[ViewSubscriptionUsage]}
      id="view-plan-usage"
      titleKey="PlanUsage.page.title"
      isLoading={isPageLoading}
      menuItems={menuItems}
    >
      <div className="usage-page-container">
        <div className="subscription-usage-container">
          <ActiveSubscriptionPlanCard
            plan={activeSubscriptionPlanStorage.activeSubscription}
            hasFreeSubscription={activeSubscriptionPlanStorage.hasFreeSubscription}
            totalFullRightsSeats={
              subscriptionPlanUsageStorage.subscriptionPlanUsage.totalFullRightsSeats
            }
            totalGuestSeats={subscriptionPlanUsageStorage.subscriptionPlanUsage.totalGuestSeats}
            totalStorageSize={subscriptionPlanUsageStorage.subscriptionPlanUsage.totalStorageSpace}
            totalVideoAnalysisCalls={
              subscriptionPlanUsageStorage.subscriptionPlanUsage.totalVideoAnalysisCalls
            }
          />
          <UsersAndSeatsUsage
            totalFullRightsSeats={
              subscriptionPlanUsageStorage.subscriptionPlanUsage.totalFullRightsSeats
            }
            usedFullRightsSeats={
              subscriptionPlanUsageStorage.subscriptionPlanUsage.usedFullRightsSeats
            }
            totalGuestSeats={subscriptionPlanUsageStorage.subscriptionPlanUsage.totalGuestSeats}
            usedGuestSeats={subscriptionPlanUsageStorage.subscriptionPlanUsage.usedGuestSeats}
          />
          <StorageSpaceUsage
            totalStorageSpace={subscriptionPlanUsageStorage.subscriptionPlanUsage.totalStorageSpace}
            usedStorageSpace={subscriptionPlanUsageStorage.subscriptionPlanUsage.usedStorageSpace}
          />
          <VideoAnalysisUsage
            totalVideoAnalysisCalls={
              subscriptionPlanUsageStorage.subscriptionPlanUsage.totalVideoAnalysisCalls
            }
            usedVideoAnalysisCalls={
              subscriptionPlanUsageStorage.subscriptionPlanUsage.usedVideoAnalysisCalls
            }
            hasFreeSubscription={activeSubscriptionPlanStorage.hasFreeSubscription}
          />
        </div>
        <div className="help-section">
          <ContactHelp />
        </div>
      </div>
    </PageLayout>
  );
});